import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Contributor } from '../../contributor'
import { Challenge } from './challenge'

export const ChallengeToContributor = pgTable(
  'challenge_to_contributor',
  {
    challengeId: uuid()
      .notNull()
      .references(() => Challenge.id, { onDelete: 'cascade' }),
    contributorId: uuid()
      .notNull()
      .references(() => Contributor.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.challengeId, table.contributorId] }),
    index('challenge_to_contributor_challenge_idx').on(table.challengeId),
    index('challenge_to_contributor_contributor_idx').on(table.contributorId),
  ],
)

export const challengeToContributorRelations = relations(ChallengeToContributor, ({ one }) => ({
  challenge: one(Challenge, {
    fields: [ChallengeToContributor.challengeId],
    references: [Challenge.id],
  }),
  contributor: one(Contributor, {
    fields: [ChallengeToContributor.contributorId],
    references: [Contributor.id],
  }),
}))

export const InsertChallengeToContributorSchema = createInsertSchema(ChallengeToContributor)
export const UpdateChallengeToContributorSchema = createUpdateSchema(ChallengeToContributor).partial()
export const SelectChallengeToContributorSchema = createSelectSchema(ChallengeToContributor)

export type InsertChallengeToContributor = typeof ChallengeToContributor.$inferInsert
export type UpdateChallengeToContributor = z.infer<typeof UpdateChallengeToContributorSchema>
export type SelectChallengeToContributor = typeof ChallengeToContributor.$inferSelect
